module.exports = __webpack_public_path__ + "static/media/article-11-option-5-1015184.dd832108.png";